import device from 'common/support/device';
import { fetchPlaybackV3Url as fetchPlaybackUrlV3Api } from 'support/api/SyncbakApi';
import { Providers, Provider, AppDispatch } from 'app-types';
import { VideoCtvRedux } from 'store-types';

export const SYNCBAK_DATA = 'SYNCBAK_DATA' as const;
export const CLEAR_SYNCBAK_DATA = 'CLEAR_SYNCBAK_DATA' as const;

export const getParamountPlusMvpdId = (state: VideoCtvRedux) => {
  const ks = state.kitchenSink.data;

  const { syncbakMvpdId } = ks.providers.paramountplus;

  const { userPackage } = state.auth.paramountPlus.user.data;

  if (userPackage === 'CBS_ALL_ACCESS_LOW_COST_PACKAGE') {
    return 'pplusLCP';
  }
  return syncbakMvpdId;
};

export const getPlaybackUrl = (
  video: { playback: { isSyncbak: boolean }; network: string } | null,
  authorizedProvider: Provider,
) => (dispatch: AppDispatch<VideoCtvRedux>, getState: () => VideoCtvRedux) => {
  const reducerState = getState();
  const ks = reducerState.kitchenSink.data;

  if (!ks || !video?.playback.isSyncbak) return null;
  const { host, key } = ks.playback.syncbakV3;
  const resource = ks.networks[video.network]?.resourceId || null;

  let mvpdId;
  if (authorizedProvider === Providers.ADOBE) {
    const adobeState = reducerState.auth.adobe;
    mvpdId = adobeState.authN?.mvpd;
  } else {
    mvpdId = getParamountPlusMvpdId(reducerState);
  }
  const station = reducerState?.geoInfo?.data?.stations;

  return dispatch(
    fetchPlaybackUrlSyncbakV3({
      host,
      key,
      resource,
      mvpdId,
      ...(station && station.length > 0 ? { station: station[0] } : {}),
    }),
  );
};

const fetchPlaybackUrlSyncbakV3 = ({
  host,
  key,
  resource,
  mvpdId,
  station,
}: {
  host: string;
  key: string;
  resource: any;
  mvpdId: any;
  station?: any;
}) => dispatch => {
  return dispatch({
    type: SYNCBAK_DATA,
    promise: httpClient =>
      device.getDeviceId().then(deviceId =>
        fetchPlaybackUrlV3Api(httpClient, {
          baseUrl: host,
          publicKey: key,
          resource,
          mvpdId,
          deviceSerialNum: deviceId,
          station,
        }),
      ),
  });
};

export const clearPlaybackUrl = () => ({
  type: CLEAR_SYNCBAK_DATA,
});
